<template>
  <div>
    <div style="padding: 2% 0;">
      <CycleInfo label="ポート名" :value="park.Station.Name"/>
    </div>  

    <DbsParkStockAndEmpty :park="park" />

      <button class="button_detail" @click="buttonAction()">
        <img
          src="@/assets/img/icon/png/i_details.png"
          style="margin-right: 5px"
          alt=""
        /><span class="button_text">詳細</span>
      </button>
    </div>
</template>

<script>
export default {
  name: "DBSFacilityCard",
  props: {
    park: {
      type: Object,
      required: true,
    },
    buttonAction: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

  button {
    width: 99%;
    height: 42px;
    margin: auto;
    padding: 0 0 8px 0;
    display: block;
    vertical-align: middle;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 0px 0px 10px 10px;

    img {
      width: 27px;
      position: relative;
      top: 8px;
    }

    .button_text {
      color: #000000;
    }
}
</style>
